
import registerSlider from "/framework/components/slider";
import "@/styles/pages/kayin/index.less";
          // window.installFramework = window.installFramework || Function.prototype
          installFramework(function(Vue) {
            // 由 vitesse 转换

new Vue({
  created($, apower, lazyLoad) {
    registerSlider($, apower);
    $.registerDirective("features", {
      bind() {
        const el = this.el;
        const items = $(el).children();
        function toggleOthers(el, className) {
          const others = $(el)
            .siblings()
            .filter((i, el) => {
              return el !== this;
            });
          others.toggleClass(className);
        }
        items.on("mouseenter", function () {
          $(this).addClass("active");
          toggleOthers(this, "inactive");
          const video = $(this).find("video")[0];
          if (video) {
            video.play();
          }
        });
        items.on("mouseleave", function () {
          $(this).removeClass("active");
          toggleOthers(this, "inactive");
          const video = $(this).find("video")[0];
          if (video) {
            video.pause();
          }
        });
      },
    });
    $.registerDirective("comments", {
      bind() {
        const items = $(".FGkWM");
        items.hide();
        items.eq(0).show();
        $(".nPWeR > div").on("click", function () {
          const current = items.filter(function (i) {
            return $(this).attr("hidden") !== "hidden";
          });
          items.hide();
          if (this.dataset.page === "left") {
            let target = current;
            if (current.prev().length !== 0) {
              target = current.prev();
            }
            target.show();
          } else {
            let target = current;
            if (current.next().length !== 0) {
              target = current.next();
            }
            target.show();
          }
        });
      },
    });
  },
});

          })
        